// extracted by mini-css-extract-plugin
module.exports = {"prefixCls":"lcam-"};